import { render, staticRenderFns } from "./survey-setting.vue?vue&type=template&id=516f89a9&"
import script from "./survey-setting.vue?vue&type=script&lang=js&"
export * from "./survey-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('516f89a9')) {
      api.createRecord('516f89a9', component.options)
    } else {
      api.reload('516f89a9', component.options)
    }
    module.hot.accept("./survey-setting.vue?vue&type=template&id=516f89a9&", function () {
      api.rerender('516f89a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/surveys/survey-setting.vue"
export default component.exports